import { createStore, combineReducers } from "redux";
import { navigationReducer } from "./reducers/navigationReducer";
import { userReducer } from "./reducers/userReducer";
import { refreshTokenReducer } from "./reducers/refreshTokenReducer";
import { authSessionReducer } from "./reducers/authSessionReducer";
import { SESSION_CHANGED } from "./actions/authSessionAction";

const initialState = {};

const reducers = combineReducers({
  navigation: navigationReducer,
  user: userReducer,
  refreshToken: refreshTokenReducer,
  authSession: authSessionReducer,
});

export const rootReducer = (state, action) => {
  if (action.type === SESSION_CHANGED) return reducers(undefined, action);
  // Async writers carry the identity captured before starting their request.
  if (action.meta && Object.prototype.hasOwnProperty.call(action.meta, "sessionId")) {
    if (!action.meta.sessionId || action.meta.sessionId !== state?.authSession.sessionId) {
      return state || reducers(undefined, { type: "@@INIT" });
    }
  }
  return reducers(state, action);
};
export default createStore(rootReducer, initialState);
